import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from '@mui/material';
import { FormInput } from 'components/input/hook-form';
import { Attendance } from 'interfaces/attendance';
import { CheckOutRequestBody, useCheckOutMutation } from 'lib/api/attendanceApi';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as yup from 'yup';
import DynamicMultipleInputFileWithButton from './DynamicMultipleInputFile';

const initialFormData: CheckOutRequestBody = {
    longitude: '',
    latitude: '',
    photos: []
};

const schema = yup.object({}).required();

interface IDialogCheckOutProps {
    open: boolean;
    handleClose: () => void;
    longitude: string;
    latitude: string;
    attendance?: Attendance;
}

const DialogCheckOut = ({ open, handleClose, latitude, longitude, attendance }: IDialogCheckOutProps) => {
    const [checkOut] = useCheckOutMutation();
    const [isLoading, setLoading] = useState(false);
    const [listFile, setListFile] = useState<any[]>([]);

    const { handleSubmit, control, reset } = useForm({
        defaultValues: initialFormData,
        mode: 'onSubmit',
        resolver: yupResolver(schema)
    });
    const handleClosee = (event?: any, reason?: any) => {
        if (!isLoading) {
            handleClose();
        }
        if (reason && reason == 'backdropClick') return;
        handleClose();
    };

    const onSubmit = async (data: CheckOutRequestBody) => {
        setLoading(true);
        data.photos = listFile;
        data.longitude = longitude;
        data.latitude = latitude;
        await checkOut({ data, id: attendance?.id ?? '-1' })
            .unwrap()
            .then((e) => {
                setLoading(false);
                withReactContent(Swal).fire('Sukses', 'Check Out Berhasil!', 'success');
            })
            .catch((error) => {});
        reset.apply(initialFormData);
        setLoading(false);
        handleClosee();
    };

    return (
        <Dialog open={open} onClose={handleClosee}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {isLoading ? (
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                ) : (
                    <div>
                        <DialogTitle variant="h3">Clock Out</DialogTitle>
                        <DialogContent>
                            <Box sx={{ mb: 20, mt: 20 }}>
                                <FormControl fullWidth>
                                    <TextField
                                        disabled
                                        label="Location Description"
                                        type="text"
                                        name="lokasi"
                                        value={attendance?.lokasi ?? '-'}
                                    />
                                </FormControl>
                            </Box>
                            <Box sx={{ mb: 20 }}>
                                <FormControl fullWidth>
                                    <TextField
                                        disabled
                                        label="What are you going to do"
                                        type="text"
                                        name="pekerjaan"
                                        value={attendance?.pekerjaan ?? '-'}
                                    />
                                </FormControl>
                            </Box>
                            <Box sx={{ mb: 20 }}>
                                <FormControl fullWidth>
                                    <TextField
                                        disabled
                                        label="Work Category"
                                        type="text"
                                        name="work_category"
                                        value={attendance?.work_category?.name ?? '-'}
                                    />
                                </FormControl>
                            </Box>
                            <Box sx={{ mb: 20 }}>
                                <FormControl fullWidth>
                                    <TextField
                                        disabled
                                        label="Cost Center"
                                        type="text"
                                        name="cost_center_id"
                                        value={attendance?.cost_center?.name ?? '-'}
                                    />
                                </FormControl>
                            </Box>
                            <Box sx={{ mb: 20 }}>
                                <FormControl fullWidth>
                                    <FormInput
                                        control={control}
                                        label="Checkout Note"
                                        placeHolder="Add a note for checkout"
                                        multiline
                                        type="text"
                                        name="checkout_note"
                                    />
                                </FormControl>
                            </Box>
                            <DynamicMultipleInputFileWithButton
                                onChange={(e) => {
                                    setListFile(e);
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button size="large" type="submit">
                                Clock Out
                            </Button>
                        </DialogActions>
                    </div>
                )}
            </form>
        </Dialog>
    );
};

export default DialogCheckOut;
